import React, {useEffect, useState} from "react";
import {buildArbitratorOptionList} from "../utils/arbitratorUtils";
import {MenuItem} from "@mui/material";
import {Tooltip} from "@material-ui/core";
import InfoIcon from "@mui/icons-material/Info";
import Select from "./common/Select";


export const ArbitratorConflictDropDown = ({name, onChange,value,label,arbitrators,pairing,schedule}) => {
    const [options, setOptions] = useState([])

    const recalculateOptions = () => {
        setOptions( buildArbitratorOptionList(pairing.claimant,pairing.respondent,arbitrators,pairing.pairingTime,schedule,pairing.id))
    }
    useEffect(() => {
        recalculateOptions()
    }, [arbitrators]);

    useEffect(() => {
        recalculateOptions()
    },[pairing])


    return (
        <Select name={name}
                onChange={e => onChange(e)}
                value={value}
                label={label}
                customRenderItems={true}
                options={options}
        renderHook={(o,index) => {
           return (<MenuItem key={o.id + index + Math.random()} value={o.id}>
                    <span className={o.isConflicted ? 'arbitrator-conflict' : ''}>
                        {o?.isConflicted ? (
                            <Tooltip title={o.reason}>
                                <span style={{display: 'flex', alignItems: 'center', cursor: 'pointer'}}>
                                    {o?.name.trim()}
                                    <InfoIcon sx={{fontSize: 14, marginLeft: '2px'}}/>
                                </span>
                            </Tooltip>
                        ) : (
                            o?.name.trim()
                        )}                        
                    </span>
            </MenuItem>
           )}}>
        </Select>
    )
}